export enum Licence {
  BASIC_LICENCE = "BASIC_LICENCE",
  DRYING_PROJECT_LICENCE = "DRYING_PROJECT_LICENCE",
  LEAK_DETECTION_PROJECT_LICENCE = "LEAK_DETECTION_PROJECT_LICENCE",

  DAMAGE_ASSESSMENT_AND_LEAK_DETECTION_LICENCE = "DAMAGE_ASSESSMENT_AND_LEAK_DETECTION_LICENCE",
  DRYING_AND_REPAIR_LICENCE = "DRYING_AND_REPAIR_LICENCE",
}

export function localiceLicence(licence: Licence, vue: Vue) {
  switch (licence) {
    case Licence.BASIC_LICENCE:
      return vue.$t("assignLicences.basic").toString();
    case Licence.DRYING_PROJECT_LICENCE:
      return vue.$t("assignLicences.drying").toString();
    case Licence.LEAK_DETECTION_PROJECT_LICENCE:
      return vue.$t("assignLicences.leakDetection").toString();
    case Licence.DAMAGE_ASSESSMENT_AND_LEAK_DETECTION_LICENCE:
      return vue
        .$t("assignLicences.damageAssessmentAndLeakDetection")
        .toString();
    case Licence.DRYING_AND_REPAIR_LICENCE:
      return vue.$t("assignLicences.dryingAndRepair").toString();
  }
}
